import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/customers/:customerId/sales-invoices/summery`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const summery = {
  get: apiPathFunc(pathBase),
};
